var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clarity:beta-line",
    clipPath: "url(#clip0_14672_28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1843 5.61896H6.6218C6.79942 5.5964 6.97979 5.61053 7.15173 5.66049C7.32367 5.71046 7.48352 5.79518 7.62138 5.90942C7.75924 6.02366 7.87219 6.16499 7.95321 6.32464C8.03423 6.4843 8.08162 6.65889 8.09242 6.8376C8.09731 7.06586 8.03529 7.29055 7.91401 7.48399C7.79274 7.67744 7.61751 7.83117 7.40992 7.92625C7.66672 8.0194 7.88942 8.18789 8.04888 8.40966C8.20834 8.63144 8.29715 8.89619 8.30367 9.16926C8.29222 9.36604 8.23998 9.55829 8.15025 9.7338C8.06053 9.90931 7.93529 10.0643 7.78248 10.1888C7.62967 10.3133 7.45263 10.4047 7.26261 10.4572C7.07259 10.5096 6.87373 10.522 6.67867 10.4935H4.1843V5.61896ZM6.38617 7.58503C6.77617 7.58503 7.05242 7.35755 7.05242 7.04071C7.05242 6.72386 6.77617 6.51263 6.38617 6.51263H5.2243V7.58503H6.38617ZM6.54867 9.59984C6.63717 9.61781 6.72856 9.61588 6.81623 9.5942C6.9039 9.57253 6.98565 9.53163 7.05558 9.47449C7.1255 9.41734 7.18185 9.34537 7.22054 9.26377C7.25924 9.18218 7.27931 9.09301 7.27931 9.00271C7.27931 8.91241 7.25924 8.82324 7.22054 8.74164C7.18185 8.66005 7.1255 8.58808 7.05558 8.53093C6.98565 8.47378 6.9039 8.43289 6.81623 8.41121C6.72856 8.38953 6.63717 8.38761 6.54867 8.40558H5.2243V9.62421L6.54867 9.59984Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1479 6.56146V7.53636H12.5854V8.47878H10.1479V9.55117H12.8535V10.4936H9.09976V5.61904H12.8535V6.56146H10.1479Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.39 6.56146H14.9094V10.4936H15.9575V6.56146H17.4525V5.61904H13.39V6.56146Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8987 9.72178L18.59 10.4936H17.42L19.4025 5.61904H20.5725L22.5631 10.4936H21.385L21.0762 9.72178H18.8987ZM20.7106 8.81187L19.9875 7.03266L19.2643 8.81187H20.7106Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56625 14.4988C4.56625 14.4988 4.76842 14.5015 4.875 14.4988H25.1875C25.403 14.4988 25.6096 14.4132 25.762 14.2608C25.9144 14.1085 26 13.9018 26 13.6864V2.31242C26 2.09696 25.9144 1.89031 25.762 1.73795C25.6096 1.58559 25.403 1.5 25.1875 1.5H0.8125C0.597012 1.5 0.390349 1.58559 0.237976 1.73795C0.0856024 1.89031 0 2.09696 0 2.31242V13.6864C0 13.9018 0.0856024 14.1085 0.237976 14.2608C0.390349 14.4132 0.597012 14.4988 0.8125 14.4988H4.56625ZM1.625 12.8739V3.12485H24.375V12.8739H8.9375C8.72435 12.8748 8.36875 12.8739 8.36875 12.8739H1.625Z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14672_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeta);
export default __webpack_public_path__ + "static/media/icon--beta.c85b6957e40ba80729ea3029478e9bcb.svg";
export { ForwardRef as ReactComponent };